export enum UserTypesEnum {
  Provider = "Provider",
  Customer = "Customer",
  Establishment = "Establishment",
  SelfEmployed = "Self-Employed",
  SalesRep = "Sales Rep",
  Employee = "Employee",
  DeliveryRepresentative = "Delivery-Representative",
  Investor = "Investor",
  Credited = "Credited",
  Uncredited = "Uncredited",
  PopupVendor = "Popup Vendor"
}

export enum DeliveryTypesEnum {
  Delivery = "delivery",
  Pickup = "pickup",
  Unassigned = "unassigned"
}

export class UserModel {
  id: string;
  image: string;
  about: string;
  email: string;
  phone: string;
  phonePrefix: string;
  name: string;
  defaultUserType: string;
  primaryUserType: string;
  secondaryUserType: string;
  provider: string;
  language: string;
  companyPagePermission: boolean;
  investorPagePermission: boolean;
  hasCompany: boolean;
  companyId: string;
  transactionId: string;
  tribalCreditBalance: number;
  createdOn: string;
  lastLogin: string;
  loginHistory: Array<string>;
  locationDetails: LocationDetails;

  constructor() {
    this.id = null;
    this.image = null;
    this.about = "";
    this.email = null;
    this.phone = null;
    this.phonePrefix = null;
    this.name = null;
    this.defaultUserType = null;
    this.primaryUserType = null;
    this.secondaryUserType = null;
    this.provider = null;
    this.language = "en";
    this.companyPagePermission = false;
    this.investorPagePermission = false;
    this.hasCompany = false;
    this.companyId = null;
    this.transactionId = null;
    this.tribalCreditBalance = 0;
    this.locationDetails = new LocationDetails();
  }
}

export class SalesRepMaster {
  repCode: number;
  uid: string;
  totalSales: number;
  valid: boolean;

  constructor(user: UserModel, idCount: number) {
    this.uid = user.id;
    this.repCode = idCount;
    this.totalSales = 0;
    this.valid = true;
  }
}

export class UrlHandles {
  handle: string;
  createdOn: any;
  for: string;
  companyId: string;

  setForCompany(handle, companyId) {
    this.for = "company";
    this.createdOn = null;
    this.handle = handle;
    this.companyId = companyId;
  }
}

export class LocationDetails {
  streetNumber: string;
  route: string;
  neighborhood: string;
  locality: string;
  country: string;
  postalCode: string;
  state: string;
  city: string;
  date: string;
  lat: number;
  lng: number;
  zoom: number;

  constructor() {
    this.streetNumber = null;
    this.route = null;
    this.neighborhood = null;
    this.locality = null;
    this.country = null;
    this.postalCode = null;
    this.state = null;
    this.city = null;
    this.date = new Date().toDateString();
    this.lat = null;
    this.lng = null;
  }
}

export class MarkerModel {
  lat: number;
  lng: number;
  type: string;
  name: string;
  draggable: boolean;
  iconUrl: string;
  redirectUrl: string;

  constructor(lat?: number, lng?: number, type?: string, name?: string, draggable?: boolean, iconUrl?: string) {
    this.lat = lat;
    this.lng = lng;
    this.type = type;
    this.name = name;
    this.draggable = draggable;
    this.iconUrl = iconUrl;
  }
}

export class FollowingModel {
  type: string;
  id: string;
  name: string;
  createdOn: number;

  followCompany(id, name) {
    this.type = "company";
    this.id = id;
    this.name = name;
    this.createdOn = Date.now();
  }

  followPerson(id, name) {
    this.type = "person";
    this.id = id;
    this.name = name;
    this.createdOn = Date.now();
  }
}

export class CartItemModel {
  id: string;
  title: string;
  image: string;
  pricePerUnit: number;
  purchaseQuantity: number;

  constructor() {
    this.id = "";
    this.title = "";
    this.image = "";
    this.pricePerUnit = 0;
    this.purchaseQuantity = 0;
  }
}

export class AddressModel {
  name: string;
  address: string;
  city: string;
  country: string;

  constructor() {
    this.name = null;
    this.address = null;
    this.city = null;
    this.country = null;
  }
}

export class CoordinatesModel {
  lat: number;
  lng: number;

  constructor() {
    this.lat = null;
    this.lng = null;
  }
}

export class TrackModel {
  // Statuses
  // complete, inprogress, pending
  delivered: {
    stage1: {
      status: string,
      subtext: string,
      text: string,
      timestamp: number,
      code: string
    },
    complete: boolean
  };
  enroute: {
    stage1: {
      status: string,
      subtext: string,
      text: string,
      timestamp: number,
      code: string
    },
    stage2: {
      status: string,
      subtext: string,
      text: string,
      timestamp: number,
      code: string
    },
    stage3: {
      status: string,
      subtext: string,
      text: string,
      timestamp: number,
      code: string
    },
    complete: boolean
  };
  ordered: {
    stage1: {
      status: string,
      subtext: string,
      text: string,
      timestamp: number,
      code: string
    },
    stage2: {
      status: string,
      subtext: string,
      text: string,
      timestamp: number,
      code: string
    },
    stage3: {
      status: string,
      subtext: string,
      text: string,
      timestamp: number,
      code: string
    },
    stage4: {
      status: string,
      subtext: string,
      text: string,
      timestamp: number,
      code: string
    },
    complete: boolean
  }

  constructor() {
    this.delivered = {
      stage1: {
        status: "pending",
        subtext: "Your order was successfully delivered to you!",
        text: "Delivered",
        timestamp: 0,
        code: "delivered"
      },
      complete: false
    };

    this.enroute = {
      stage1: {
        status: "pending",
        subtext: "Your order has reached your city!",
        text: "In your City",
        timestamp: 0,
        code: "city"
      },
      stage2: {
        status: "pending",
        subtext: "Your order has been reached our distribution center to be sorted and sent out to you!",
        text: "At a Distribution Center near You",
        timestamp: 0,
        code: "center"
      },
      stage3: {
        status: "pending",
        subtext: "Your order is out for delivery!",
        text: "Out for Delivery",
        timestamp: 0,
        code: "delivery"
      },
      complete: false
    };

    this.ordered = {
      stage1: {
        status: "pending",
        subtext: "Your order has been placed. We will confirm your order once it has been processed!",
        text: "Order Placed",
        timestamp: 0,
        code: "placed"
      },
      stage2: {
        status: "pending",
        subtext: "Your order has been processed. We will confirm your order once the seller approves!",
        text: "Order Processing",
        timestamp: 0,
        code: "processing"
      },
      stage3: {
        status: "pending",
        subtext: "Your order has been confirmed!",
        text: "Order Confirmed",
        timestamp: 0,
        code: "confirmed"
      },
      stage4: {
        status: "pending",
        subtext: "Your order has left the sellers facility!",
        text: "Order Shipped",
        timestamp: 0,
        code: "shipped"
      },
      complete: false
    }
  }

  setToStage1() {
    this.ordered.stage1.status = "completed";
    this.ordered.stage1.timestamp = Date.now();

    this.ordered.stage2.status = "inprogress";
  }
}

export class DeliveryModel {
  deliveryType: string;
  address: AddressModel;
  coord: CoordinatesModel;

  constructor() {
    this.deliveryType = DeliveryTypesEnum.Unassigned; // So as to track when location is not selected for delivery
    this.address = new AddressModel();
    this.coord = new CoordinatesModel();
  }
}

export class CartModel {
  items: Array<CartItemModel>;
  companyId: string;
  totalPrice: number;
  numberOfItems: number;
  // Never save any currency value other than USD this is is temporary varibale
  currency: string;
  billingAddress: AddressModel;
  delivery: DeliveryModel;

  constructor() {
    this.items = new Array<CartItemModel>();
    this.totalPrice = 0;
    this.numberOfItems = 0;
    this.companyId = null;
    // Currency only chnages temporarily in cart page
    // Change in currency only affects the total price
    this.currency = null;
    this.billingAddress = new AddressModel();
    this.delivery = new DeliveryModel();
  }
}

export class TransactionModel {
  items: Array<CartItemModel>;

  totalPrice: number;
  numberOfItems: number;
  // Never save any currency value other than USD this is is temporary varibale
  currency: string;
  timestamp: number;
  id: string;
  trackObj: TrackModel;
  status: string;
  billingAddress: AddressModel;
  delivery: DeliveryModel;
  paymentSource: string;
  refferalCode: string;

  constructor(cart: CartModel, id: string, paymentSource: string, refferalCode?: string) {
    this.items = cart.items;
    this.totalPrice = cart.totalPrice;
    this.numberOfItems = cart.numberOfItems;
    this.currency = cart.currency;
    this.delivery = cart.delivery;
    this.billingAddress = cart.billingAddress;
    this.paymentSource = paymentSource;
    if (refferalCode) this.refferalCode = refferalCode;

    this.id = id;
    this.timestamp = Date.now();

    this.status = "active";

    this.trackObj = new TrackModel();
    this.trackObj.setToStage1();
  }
}

export class ProfileModel {
  user: UserModel = new UserModel();
  locationDetails: LocationDetails = new LocationDetails();
  following: Array<FollowingModel> = new Array<FollowingModel>();
  cart: CartModel = new CartModel();
  name: string;
  email: string;
  contractId: Array<string>;

  constructor() {
    this.user = new UserModel();
    this.locationDetails = new LocationDetails();
    this.following = new Array<FollowingModel>();
    this.cart = new CartModel();
    this.contractId = null;
  }

  mapUserToProfile(user, locationDetails?: LocationDetails) {
    var date = new Date();

    this.user.id = user.uid;
    this.user.name = user.displayName ? user.displayName : user.name;
    this.user.image = user.photoURL ? user.photoURL : "assets/images/user.png";
    this.user.email = user.email;
    this.user.language = "en";
    this.user.defaultUserType = 'Customer';
    this.user.createdOn = date.toString();
    this.user.lastLogin = date.toString();
    this.user.loginHistory = [
      date.toString()
    ];
    this.name = user.displayName ? user.displayName : user.name;
    this.email = user.email;

    this.cart = new CartModel();
    this.locationDetails = new LocationDetails();

    if (locationDetails) {
      this.locationDetails = locationDetails;
      this.user.locationDetails = locationDetails; // Set in user object too
    }
  }
}

export class ProfileListModel {
  name: string;
  image: string;
  about: string;
  id: string;
  followers: number;
  active: boolean;


  constructor() {
    this.active = false;
  }
}



// WEBPACK FOOTER //
// ./src/models/profile.model.ts